<cap-beschreibung-table-wrapper>
  <span class="cap-table-wrapper-title" style="font-weight: bold">
    {{ "DominierteGrundstuecke" | translate }}
  </span>
  <ng-container class="cap-table-wrapper-content">
    <cap-list-loader [listLoader]="listLoader" [showTotal]="false" [showZeilenSelect]="false">
      <div class="cap-list-loader-content">
        <table class="cap-table-detail">
          <thead>
            <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
          </thead>
          <tbody>
            <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
          </tbody>
        </table>
      </div>
    </cap-list-loader>
    <ng-template #tableHeaders>
      <tr>
        <th style="width: 20%">{{ "Grundstueck" | translate }}</th>
        <th style="width: 20%">
          <span class="float-end pe-3">
            {{ "AnteilAmDominiertenGrundstueck" | translate }}
          </span>
        </th>
        @if (rechtsgrundDatumAnzeigen && belegeAnzeigen) {
          <th [style]="'width: 10%'">{{ "DatumEntstehungErgänzung" | translate }}</th>
        }
        @if (rechtsgrundDatumAnzeigen && !belegeAnzeigen) {
          <th [style]="'width: 20%'">{{ "DatumEntstehung" | translate }}</th>
        }
        @if (belegeAnzeigen) {
          <th [style]="rechtsgrundDatumAnzeigen ? 'width: 10%' : 'width: 20%'">{{ "Beleg" | translate }}</th>
        }
      </tr>
    </ng-template>
    <ng-template #tableRows>
      @if (listLoader?.items) {
        @for (eigentumanteil of listLoader?.items | orderByGrundstuecknummer: true : "belastetesGrundstueck"; track eigentumanteil) {
          @if (eigentumanteil.object.belastetesGrundstueck) {
            @for (version of eigentumanteil.versionenVm; track version) {
              <tr>
                <td [capHistinfo]="version.object.histInfo">
                  <cap-kompakt-grundstueck [item]="eigentumanteil.object.belastetesGrundstueck" [navigateTo]="navigateTo">
                  </cap-kompakt-grundstueck>
                </td>
                <td>
                  <span [capHistinfo]="version.object.histInfo" class="float-end pe-3">
                    {{ version.quoteValue }}
                  </span>
                  <cap-kompakt-timepoint [item]="version.object.histInfo?.bisTimePoint" loeschgeschaeft></cap-kompakt-timepoint>
                </td>
                @if (rechtsgrundDatumAnzeigen) {
                  <td>
                    @for (rechtsgrund of eigentumanteil.object.rechtsgruende; track rechtsgrund) {
                      <div>
                        <cap-rechtsgrund-icp [rechtsgrund]="rechtsgrund"></cap-rechtsgrund-icp>
                      </div>
                    }
                  </td>
                }
                @if (belegeAnzeigen) {
                  <td>
                    @for (rechtsgrund of eigentumanteil.object.rechtsgruende; track rechtsgrund) {
                      <div>
                        <span>{{ rechtsgrund.beleg | formatBeleg: false }}</span>
                      </div>
                    }
                  </td>
                }
              </tr>
            }
          }
        }
      }
    </ng-template>
  </ng-container>
</cap-beschreibung-table-wrapper>
